<!-- Put all the HTML HERE

    Remember: Your HTML should have only one root element
 -->
<template>
    <div>This is the user component</div>
</template>


<script>
    export default {
//        Component Name
        name: "UserComponent",
        data() {
            return {}
        },
        methods: {}
    }
</script>